<div class="clics-icon" [class.active]="active" [class.special]="special" [class.dark]="(theme=='dark' && !reverse) || (theme=='light' && reverse)" [class.text-only]="!useIcon">
  <span class="text" [innerHTML]="label" *ngIf="!useIcon || isDual"></span>
  <span class="spacer" *ngIf="isDual">&nbsp;</span>
  <div class="icon">
    <ion-icon name="{{source}}" *ngIf="!isImage && useIcon || isDual" [class.dual]="isDual"></ion-icon>
    <img src="{{source}}" *ngIf="(isImage && useIcon) || (isImage && isDual)" [class.dual]="isDual" alt="{{label + ' icon'}}" />
  </div>
  <p [innerHTML]="label" *ngIf="useIcon && !iconOnly"></p>
</div>
